import httpHubless from 'hub-http/clients/noPortalApiClient';
import * as TwoFactorAuthMethods from '../constants/TwoFactorAuthMethods';
import * as TwoFactorAuthPrecedenceTypes from '../constants/TwoFactorAuthPrecedenceTypes';
const API_BASE = 'two-factor/v1';
export function fetchStatus() {
  return httpHubless.get(`${API_BASE}/status/hubless`);
}
export function fetchSetupStatus(portalId) {
  return httpHubless.get(`${API_BASE}/two-factor-required-portals/details`, {
    query: {
      portalId
    }
  });
}
export function configureGoogleAuth(precedence) {
  return httpHubless.post(`${API_BASE}/setup/configure/hubless/${precedence}`, {
    data: {
      method: TwoFactorAuthMethods.GOOGLE_AUTHENTICATOR
    }
  });
}
export function configureSMS(precedence, number) {
  return httpHubless.post(`${API_BASE}/setup/configure/hubless/${precedence}`, {
    data: {
      method: TwoFactorAuthMethods.SMS,
      info: number
    }
  });
}
export function confirmVerificationCode(precedence, codeAttempt) {
  return httpHubless.put(`${API_BASE}/setup/confirm/hubless/${precedence}`, {
    data: {
      codeAttempt
    }
  });
}
export function deleteConfig(precedence, promote) {
  if (precedence === TwoFactorAuthPrecedenceTypes.ALL) {
    return httpHubless.post(`${API_BASE}/setup/disable-all/hubless`, {
      query: {
        promote
      }
    });
  }
  return httpHubless.delete(`${API_BASE}/setup/hubless/${precedence}`, {
    query: {
      promote
    }
  });
}
export function generateBackupCodes() {
  return httpHubless.post(`${API_BASE}/backup-codes/hubless`);
}